import template from '@components/expertise/discovery/discovery.module.scss'
import { IMainApproachesSection } from '../../discovery.state';
import style from './index.module.scss'
import Image from 'next/image'

interface MainApproachesSectionProps {
    section: IMainApproachesSection;
}

const MainApproachesSectionComponent = ({ section }: MainApproachesSectionProps) => {
    return (
        <section className={`${template.section} ${template.section__block_gray}`}>
            <div className={`${template.container}`}>
                <h2 className={template.block_large__title}>
                    {section.title}
                </h2>
                <div className={template.approaches}>
                    <div className={template.approaches__items}>
                        {
                            section.text.map((item: string, index: number) => {
                                return (
                                    <div key={index} className={template.approaches__item}>
                                        {item}
                                    </div>
                                )
                            })
                        }
                    </div>
                    <div className={template.approaches__image}>
                        <Image src={section.imgSrc} layout={'fill'} alt={section.title} />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default MainApproachesSectionComponent;